import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'

import { getMeetingRecordingData } from '../../../Redux/action/MasterAction';
import StudentSidebar from '../StudentSidebar/StudentSidebar';
import Beatloader from '../../../Common/BeatLoader';
import ResponsivePagination from '../../../Common/Pagination';



const host = process.env.REACT_APP_API_SERVER
const StudentRecordedVideos = () => {
    const [video, setVideo] = useState();
    const dispatch = useDispatch();
    const { b64id } = useParams();
    const navigate = useNavigate();
    const BatchId = atob(b64id);
    const location = useLocation();
    const courseName = location.state.course

    useEffect(() => {
        try {




            if (!BatchId) {
                throw new Error("Invalid Meeting ID");
            }


            dispatch(getMeetingRecordingData(BatchId, 1))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);
    const {


        loadingMeetingRecListDataApi,
        MeetingRecListDataApiData,
        MeetingRecListDataApiError,
        MeetingRecListCurrentPage,
        MeetingRecListPerPageData,
        MeetingRecListTotalData

    } = useSelector(state => state?.MasterReducer);

    const handleVideoClick = (v) => {
        setVideo(v)


    }

    //pagination
   const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!MeetingRecListDataApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(MeetingRecListDataApiData.slice(start, end));
        setPageCount(Math.ceil(MeetingRecListDataApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, MeetingRecListDataApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };


    useEffect(() => {
        const modal = document.getElementById('videoModal');
        const videoEl = modal?.querySelector('video');

        const stopVideo = () => {
            if (videoEl) {
                videoEl.pause();
                videoEl.currentTime = 0; // Optional: reset to beginning
            }
        };

        if (modal) {
            modal.addEventListener('hidden.bs.modal', stopVideo);
        }

        // Cleanup on component unmount
        return () => {
            if (modal) {
                modal.removeEventListener('hidden.bs.modal', stopVideo);
            }
        };
    }, []);



    return (
        <div className='pagination-component'>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Recordings
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    <h4>Course: {courseName}</h4>

                                    <div className="tab-content-student my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingMeetingRecListDataApi ?
                                                <Beatloader />
                                                :
                                                <div className="row">
                                                    {MeetingRecListDataApiData?.length > 0 ?
                                                        currentData?.map((data) => (
                                                            <div className="col-lg-6 mt-3 col-md-6">
                                                                <div
                                                                    className="card input-card-form notescard"
                                                                    style={{ backgroundColor: "aliceblue" }}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#videoModal"
                                                                    onClick={() => { handleVideoClick(data?.file?.fileUrl) }}
                                                                >
                                                                    <div className="card-body">
                                                                        <div className="row gap-0">
                                                                            <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                                {/* Trigger button for modal */}
                                                                                <img
                                                                                    src="/assets/img/user/play.png"
                                                                                    className="img-fluid play-button"
                                                                                    style={{
                                                                                        height: 85,
                                                                                        width: "auto",
                                                                                        borderRadius: 15,
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#videoModal"
                                                                                />
                                                                            </div>
                                                                            <div className="col-lg-8 m-0 p-0 d-flex flex-column text-center justify-content-center col-md-8 col-sm-8 ">
                                                                                <h5 className="mb-0 text-dark text-center">
                                                                                    {data?.study_material?.material_name}
                                                                                </h5>
                                                                                <p className="mb-0">{new Date(data?.createdAt).toDateString()}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}

                                                </div>

                                            }


                                           {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}
                                            {/* CSS for styling the pagination */}
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        "\n                                        .pagination .page-item .page-link {\n                                            border: none;\n                                            margin: 0 5px;\n                                            padding: 10px 15px;\n                                            color: #555;\n                                            font-weight: 500;\n                                            font-size: 1rem;\n                                            border-radius: 8px;\n                                            transition: all 0.3s ease;\n                                            background-color: #f1f3f5;\n                                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n                                        }\n                                    \n                                        /* Hover effect */\n                                        .pagination .page-item .page-link:hover {\n                                            background-color: #e0e4e7;\n                                            color: #333;\n                                            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n                                            transform: translateY(-2px);\n                                        }\n                                    \n                                        /* Active page styling */\n                                        .pagination .page-item.active .page-link {\n                                            background-color: #007bff;\n                                            color: #fff;\n                                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n                                        }\n                                    \n                                        /* Disabled button styling */\n                                        .pagination .page-item.disabled .page-link {\n                                            color: #aaa;\n                                            background-color: #f1f3f5;\n                                            pointer-events: none;\n                                        }\n                                    \n                                        /* Chevron icon styling */\n                                        .pagination .page-item .page-link i {\n                                            font-size: 1rem;\n                                        }\n                                    "
                                                }}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* video popup */}
                <div
                    className="modal fade"
                    id="videoModal"
                    tabIndex={-1}
                    aria-labelledby="videoModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="d-flex justify-content-between">
                                    <h5 className="modal-title" id="videoModalLabel">
                                        Recorded Video
                                    </h5>

                                    <a download
                                        href={video}
                                        className='ms-2' title='Download Recording'
                                    > <i className='fa fa-download'></i></a>
                                </div>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />


                            </div>
                            <div className="modal-body">
                                <div className="ratio ratio-16x9">
                                    <video
                                        className="img-fluid w-100"
                                        src={video}

                                        controls
                                        playsInline
                                        loading="eager"
                                    >
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default StudentRecordedVideos